// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XpRF","field":"styles_field__CU9bU","fieldCol":"styles_fieldCol__2cbGQ","diffCol":"styles_diffCol__2WiNH","diff":"styles_diff__1vlSY"};